import { connectInfiniteHits } from 'react-instantsearch-dom'
import { compose } from 'redux'

import { Hits } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Hits'
import { withAdServerMetadataContext } from 'views/enhancers/withAdServerMetadataContext'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

export default compose(
  connectInfiniteHits,
  withShopAndRuntimeConfig,
  withAdServerMetadataContext
)(Hits)
